<template>
  <div class="contacts-page">
    <div class="contacts-page__container">
      <AppBreadcrumbs :crumbs="[{ path: '/contacts', name: 'Контакты' }]" />
    </div>
    <ContactsSection
      :contact-page="true"
      :data="page"
      :socials-list="socialsList"
    />

    <AgentsList
      :agents="agents"
    />
  </div>
</template>
<script>
import ContactsSection from "@/components/ContactsSection.vue";
import AgentsList from "@/components/AgentsList.vue";
import AppBreadcrumbs from "@/components/ui/AppBreadcrumbs.vue";

export default {
  components: { ContactsSection, AgentsList, AppBreadcrumbs },
};
</script>

<script setup>
import { onMounted, ref } from "vue";
const axios = require("axios");

const page = ref({});
const socialsList = ref([]);
const agents = ref([]);

onMounted(async () => {
  axios.get("/api/getPageElements?name=contacts").then(({ data }) => {
    page.value = data.blocks.main_banner.elements;
    socialsList.value = data.blocks.main_banner.elements.list.source[0].social;
  });

  axios.get('/api/getAllAgents').then(({ data }) => {
    agents.value = data.agents;
  });
});
</script>

<style lang="scss" scoped>
.contacts-page {
  padding-top: 114px;
  overflow: hidden;

  @include phone {
    padding-top: 86px;
  }

  .breadcrumbs {
    margin-bottom: 40px;

    @include desktop {
      margin-bottom: 28px;
    }
  }

  &__container {
    @extend %container;
  }
}
</style>
